import React, {Component} from 'react';

import './ObjectSearchItemEmpty.css';

class ObjectSearchItemEmpty extends Component {

	render() {

		const componentName = "objectsearchitemempty";

		return (
			<li className={`${componentName}${this.props.classModifier}`}>
				<i className={`${componentName}-icon`}></i>
				<h5 className={`${componentName}-title`}>{this.props.title}</h5>
				<p className={`${componentName}-text`}>{this.props.text}</p>
			</li>
		)
	}
}

export default ObjectSearchItemEmpty;



// WEBPACK FOOTER //
// ./src/js/components/ObjectSearchItemEmpty.js